import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Share, Plus, Check } from "lucide-react";

export const IOSInstallDialog = ({ open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm" data-testid="ios-install-dialog">
      <DialogHeader>
        <DialogTitle className="font-head">Installa K9 Manager</DialogTitle>
        <DialogDescription>Per avere K9 Manager sulla schermata Home:</DialogDescription>
      </DialogHeader>
      <ol className="space-y-3 text-sm">
        <li className="flex items-center gap-3">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-secondary text-foreground shrink-0"><Share className="h-4 w-4" /></span>
          <span>Tocca <b>Condividi</b></span>
        </li>
        <li className="flex items-center gap-3">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-secondary text-foreground shrink-0"><Plus className="h-4 w-4" /></span>
          <span>Scegli <b>“Aggiungi alla schermata Home”</b></span>
        </li>
        <li className="flex items-center gap-3">
          <span className="grid place-items-center h-8 w-8 rounded-lg bg-secondary text-foreground shrink-0"><Check className="h-4 w-4" /></span>
          <span>Tocca <b>“Aggiungi”</b></span>
        </li>
      </ol>
    </DialogContent>
  </Dialog>
);
